import React from "react";
import EndingCards from "./sub-components/EndingCard";
import { EndingCardsSkeleton } from "./sub-components/skeleton";

const Ebay = ({ totalFreightCount, totalGroundCount, isScreeningLoading }) => {
  return (
    <div style={{ marginTop: 38 }}>
      {isScreeningLoading ? (
        <EndingCardsSkeleton />
      ) : (
        <EndingCards
          totalFreightCount={totalFreightCount}
          totalGroundCount={totalGroundCount}
        />
      )}
    </div>
  );
};

export default Ebay;
// checked
